// extracted by mini-css-extract-plugin
export default {"img1":"Banner1_img1__pRoaZ","text2":"Banner1_text2__mubid","text1":"Banner1_text1__AbZml","img2":"Banner1_img2__qN84d","know_more":"Banner1_know_more__MSvfV"};